import { Link } from 'react-router-dom';
import { ChefHat, Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-navy text-white py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <ChefHat className="w-8 h-8 text-terracotta" />
              <span className="font-display text-xl font-bold">Schmackofatz</span>
            </Link>
            <p className="text-white/70 text-sm">
              Entdecke köstliche Rezepte aus aller Welt und teile deine Lieblingsgerichte.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/70 hover:text-terracotta transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/rezepte" className="text-white/70 hover:text-terracotta transition-colors">
                  Rezepte
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-white/70 hover:text-terracotta transition-colors">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-white/70 hover:text-terracotta transition-colors">
                  Anmelden
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-display text-lg font-semibold mb-4">Kategorien</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/rezepte?kategorie=fruehstueck" className="text-white/70 hover:text-terracotta transition-colors">
                  Frühstück
                </Link>
              </li>
              <li>
                <Link to="/rezepte?kategorie=mittagessen" className="text-white/70 hover:text-terracotta transition-colors">
                  Mittagessen
                </Link>
              </li>
              <li>
                <Link to="/rezepte?kategorie=abendessen" className="text-white/70 hover:text-terracotta transition-colors">
                  Abendessen
                </Link>
              </li>
              <li>
                <Link to="/rezepte?kategorie=dessert" className="text-white/70 hover:text-terracotta transition-colors">
                  Desserts
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Schmackofatz. Alle Rechte vorbehalten.
          </p>
          <p className="text-white/50 text-sm flex items-center gap-1">
            Gemacht mit <Heart className="w-4 h-4 text-terracotta fill-terracotta" /> für Genießer
          </p>
        </div>
      </div>
    </footer>
  );
};
